/* eslint prefer-template: 0 */
import $ from "jquery";

(function () {
    const getCsvUrl = "/api/TableLookUp/GetCsvCrossReference";
    function setCsvValueToHtml(result) {
        if (result) {
            $(".table-lookup[data-guid=\"" + result.id + "\"]").find(".tableLookUpResult").html(result.value);
        } else {
            console.error("Unable to get CSV Value for Table Lookup component: " + result);
        }
    }

    function getCSVValue(itemId, columnVal, rowVal) {
        const url = getCsvUrl + "?column=" + columnVal + "&row=" + rowVal + "&itemId=" + itemId;
        $.get(url, setCsvValueToHtml);
    }

    $(document).ready(() => {
        $(".table-lookup select").change((e) => {
            const tableLookUpDiv = $(e.target).closest(".table-lookup");
            const itemId = tableLookUpDiv.attr("data-guid");
            const columnVal = $(tableLookUpDiv).find(".columnDropDown").val();
            const rowVal = $(tableLookUpDiv).find(".rowDropDown").val();
            if (rowVal && columnVal) {
                getCSVValue(itemId, columnVal, rowVal);
            }
        });
    });
}());
